import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatDialog, PageEvent } from "@angular/material";
import { fromEvent, Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, map } from "rxjs/operators";
import { Patient } from "src/app/core/model/patient";
import { CaseManagementService } from "src/app/core/services/v2/case-management.service";
import { CommonService } from "src/app/core/services/v2/common.service";
import { PracticeService } from "src/app/core/services/v2/practice.service";
import { PhysicianPatientProfileComponent } from "src/app/physician/patient/physician-patient-profile/physician-patient-profile.component";
import { SidebarPhysicianEditComponent } from "src/app/physician/profile/physician/sidebar-physician-edit/sidebar-physician-edit.component";
import { PhysicianOptionService } from "src/app/physician/shared/physician-option/physician-option.service";
import { PreviewDocumentComponent } from "src/app/shared/components/preview-document/preview-document.component";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { Case } from "../models/casehistory";
import { SearchCaseRequest } from "../models/searcCaseRequest";
import { CaseSummaryComponent } from "./case-summary/case-summary.component";

@Component({
  selector: "casemanager-caselist",
  templateUrl: "./caselist.component.html",
  styleUrls: ["./caselist.component.scss"],
})
export class CaselistComponent implements OnInit, AfterViewInit {
  //uploadedFile: PractitionerDocument;
  userId: number;
  toggleSidebar = false;
  sectionName: string = "referPatient";

  searchCriteria: string = "";

  pageLength = 10;
  pageIndex = 1;
  dataLength;

  searchData: Case[];

  displayedColumns: string[] = [
    "caseName",
    "caseTypeCodeItem",
    "caseNumber",
    "creationDate",
    "patientName",
    "legalPractice",
    "lastUpdateByWhen",
    // "email",
    // "contact",
    // "aptDateTime",
    // "nextAptDateTime",
    // "symptoms",
    "action",
  ];
  sideBarHeader = "Case Details";
  // dataSource: SearchPatientRes[];
  dataSource: Case[];
  role: string;
  //selectedPatient: Case;
  selectedPatient: Patient;
  togglePatientProfileSidebar = this.commonService.togglePatientProfileSidebar;
  showPatientProfile: boolean = false;

  links = ["Open", "Close"];
  activeLink = this.links[0];
  @ViewChild(SidebarPhysicianEditComponent, { static: false })
  childComponent: SidebarPhysicianEditComponent;
  @ViewChild("patientSearchInput", { static: true })
  patientSearchInput: ElementRef;
  caseModel: Case;
  constructor(
    private caseManagementService: CaseManagementService,
    private physicianOptionService: PhysicianOptionService,
    private loaderService: WindowLoaderService,
    public dialog: MatDialog,
    private commonService: CommonService
  ) {}

  changeIndex(event: PageEvent) {
    this.pageLength = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.searchPatient();
  }

  ngOnInit() {
    //this.searchPatient();
    this.physicianOptionService.selectionChange$.subscribe(
      (_) => {
        this.searchCriteria = "";
        this.searchPatient();
      },
      (error) => {
        console.error(error);
      }
    );

    fromEvent(this.patientSearchInput.nativeElement, "keyup")
      .pipe(
        map((event: any) => {
          return event.target.value;
        }),
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((text: string) => {
        this.searchCriteria = text;
        this.searchPatient();
      });
  }
  onSelectOfTab(link) {
    this.activeLink = link;
    if (link == "Open") {
      this.searchPatient();
    } else {
      this.searchPatient(true);
    }
  }
  ngAfterViewInit() {
    // this.searchPatient();
  }

  toggleEditSidebar(sectionName: string, data: any) {
    this.sectionName = sectionName;
    this.setSidebarHeader(sectionName);
    if (sectionName == "addCase") {
      this.caseModel = new Case();
      this.caseModel.caseManagerId =
        this.physicianOptionService.getPhysician().id;
      this.caseModel.caseStatusCodeItem = "Active";
    } else if (sectionName == "updateCase") {
      this.caseModel = { ...data };
      this.caseModel.patientName =
        data.patient.firstName + " " + data.patient.lastName;
      this.caseModel.patient = null;
      this.caseModel.legalPractice = null;
      this.caseModel.healthSystem = null;
      this.caseModel.practitioner = null;
    } else {
      this.caseModel = data;
    }
    if (this.caseModel != null) {
      this.caseModel.authorUserId =
        this.physicianOptionService.getPhysician().userId;
    }
    //this.selectedPatient = patient;
    this.toggleSidebar = !this.toggleSidebar;
    this.showHideScroll(this.toggleSidebar);
    this.destroyChild();
  }
  togglePatientreferralEditSidebar(sectionName: string, data: any) {
    this.sectionName = sectionName;
    this.toggleSidebar = !this.toggleSidebar;
    this.showHideScroll(this.toggleSidebar);
    this.destroyChild();
  }

  togglePopUp() {
    this.searchPatient();
    // this.practitionerData = pracdata;
    this.toggleSidebar = !this.toggleSidebar;
    this.showHideScroll(this.toggleSidebar);
    this.destroyChild();
  }

  showHideScroll(isOpen: boolean) {
    /* To stop body scroll while sidebar is Open */
    const body = document.querySelector("body");
    if (isOpen) {
      body.style.cssText = "height:100vh; overflow:hidden";
    } else {
      body.style.cssText = "height:auto; overflow:visible";
    }
  }

  destroyChild() {
    if (this.childComponent) {
      this.childComponent.ngOnDestroy();
    }
  }

  searchPatient(isClosed: boolean = false) {
    const searchReq: SearchCaseRequest = new SearchCaseRequest();
    searchReq.userId = this.physicianOptionService.getPhysician().userId;
    searchReq.pageIndex = this.pageIndex;
    searchReq.itemsCount = this.pageLength;
    searchReq.criteria = this.searchCriteria;
    searchReq.isClosedCases = isClosed;
    if (searchReq.userId) {
      this.loaderService.show();
      this.caseManagementService.getCaseList(searchReq).subscribe(
        (res) => {
          this.searchData = res.result.cases;
          this.dataSource = res.result.cases;
          this.dataLength = res.result.totalRecords;

          if (this.dataLength < (this.pageIndex - 1) * this.pageLength)
            this.pageIndex = 1;

          this.loaderService.hide();
        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        },
        () => {
          this.loaderService.hide();
        }
      );
    }
  }

  togglePatientSidebar(element) {
    this.selectedPatient = element;
    this.showPatientProfile = !this.showPatientProfile;
    this.togglePatientProfileSidebar = !this.togglePatientProfileSidebar;
  }
  openCaseSummaryPopup(caseData: Case) {
    if (caseData)
      this.dialog.open(CaseSummaryComponent, {
        id: "caseSummary",
        width: "95%",
        data: {
          caseData: caseData,
        },
      });
  }

  setSidebarHeader(sectionName: string) {
    switch (sectionName) {
      case "addCase":
      case "updateCase":
        this.sideBarHeader = "Case Details";
        break;
      case "caseDocuments":
        this.sideBarHeader = "Case Documents";
        break;
      case "nursingNotes":
        this.sideBarHeader = "Nursing Note";
        break;
      case "assignCaseManager":
        this.sideBarHeader = "Assign Case Manager";
        break;
      case "caseCommunication":
        this.sideBarHeader = "Case Communication";
        break;
      default:
        this.sideBarHeader = null;
        break;
    }
  }
  // getPractitionerPatientDocument() {
  //   this.practiceService
  //     .getPractitionerPatientDocument(
  //       this.physicianOptionService.getPhysician().id
  //     )
  //     .subscribe((res) => {
  //       this.uploadedFile = res;
  //       console.log(this.uploadedFile);
  //     });
  // }

  // deleteFile(file) {
  //   this.practiceService
  //     .deletePractitionerPatientDocument(file.id)
  //     .subscribe((res) => console.log(res));
  // }

  // viewFile(file: File) {
  //   const dialogRef = this.dialog.open(PreviewDocumentComponent, {
  //     id: "view-dialog",
  //     width: "90%",
  //     height: "90%",
  //     hasBackdrop: true,
  //     disableClose: true,
  //     backdropClass: "preview-modal",
  //     data: { documentLocation: file, isFrame: true },
  //   });
  // }
}
